export class StringUtils {
  static truncate(str: string | undefined, substr: string, n = 1): string {
    if (!str) return '';
    const re = new RegExp('\\' + substr, 'g');
    let match: RegExpMatchArray | null;
    let count = 0;
    let lastIndex = str.length;

    while ((match = re.exec(str)) !== null) {
      count++;
      if (!match.index) return '';
      if (count === n) {
        return str.substring(0, match.index + substr.length - 1);
      }
      lastIndex = match.index + substr.length - 1;
    }

    return str.substring(0, lastIndex);
  }
}
